import { lazy } from "react";

const Dashboard = lazy(() => import("../pages/dashboard"));
const  Category = lazy(() => import("../pages/catogory"));
const  ViewService  = lazy(() => import("../pages/catogory/compoenet/viewservice"));
const  Summary  = lazy(() => import("../pages/summary"));
const Cart  = lazy(() => import("../pages/cart"));
const Login    = lazy(() => import("../authentication/login"));

const AllCategory   = lazy(() => import("../pages/catogory/compoenet/allcatogray"));
const Register  = lazy(() => import("../authentication/register"));
const BookingHistory  = lazy(() => import("../pages/profilesettings/component/bookinghistory"));
const Profile   = lazy(() => import("../pages/profilesettings/component/profile"));
const ProfileLayout   = lazy(() => import("../pages/profilesettings/profilelayout"));
const ViewBooking   = lazy(() => import("../pages/profilesettings/component/viewbookings"));



const ResetPassoword   = lazy(() => import("../authentication/resetpassoword"));






export const Routes = [
  {
    path: "/home",
    element: <Dashboard/>, 
  },
    {
    path: "/ressetpassword",
    element: <ResetPassoword/>, 
        layout: 'modal',  // Indicate it's a modal so you can style it with higher z-index

  },
  {
    path: "/login",
    element: <Login/>, 
  },
  {
    path: "/register",
    element: <Register/>, 
  },
  {
    path: "/home/category",
    element: <Category/>, 
  },
  {
    path: "/home/category/viewService",
    element: <ViewService />, 
  },
  {
    path: "/home/cart/ordersummary",
    element: <Summary/>, 
  },

  {
    path: "/home/cart",
    element: <Cart/>, 
  },


  {
    path: "/home/allcatogray",
    element: <AllCategory/>, 
  },
  {
    path: "/home/profilesetting",
    element: <ProfileLayout />, // layout with sidebar
    children: [
      {
        index: true,
        element: <Profile />, // 👈 this gets rendered by default!
      },
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "bookingHistory",
        element: <BookingHistory />,
      },
      {
        path: "bookingHistory/:bookingId",
        element: <ViewBooking />,
      },
    ],
  }

];

export default { Routes };
